export const enum EBitrateBitsMultiple {
  kilobitPerSecond = 1000,
  megabitPerSecond = 1000000,
}

export const convertBitrates = (bitrate: number, multiplier: number, type: 'multiple' | 'divide'): number => {
  if (bitrate) {
    if (type === 'multiple') {
      return bitrate * multiplier;
    } else if (type === 'divide') {
      return bitrate / multiplier;
    }
  }

  return bitrate;
};
